export const PACKAGING_TYPES = {
  NO_PACKAGING: 'NO',
  GIFT_PACKAGING: '500',
};

export const PACKAGING_OPTIONS = [
  {
    label: 'No gift packaging',
    value: PACKAGING_TYPES.NO_PACKAGING,
  },
  {
    label: 'Gift packaging, $7.50',
    term: 'Free for qualifying InCircle members',
    value: PACKAGING_TYPES.GIFT_PACKAGING,
  },
];

export const GIFT_NOTE_TYPES = {
  NO_GIFT_NOTE: '0',
  FREE_BLANK_NOTE: '1',
  FREE_CUSTOM_MESSAGE: '2',
};

export const NOTE_OPTIONS = [
  {
    label: 'No Gift Note',
    value: GIFT_NOTE_TYPES.NO_GIFT_NOTE,
  },
  {
    label: 'Free Blank Gift Note',
    value: GIFT_NOTE_TYPES.FREE_BLANK_NOTE,
  },
  {
    label: 'Free Custom Message',
    value: GIFT_NOTE_TYPES.FREE_CUSTOM_MESSAGE,
  },
];

export const GIFT_ERRORS = {
  CHARS: 'Row can have a maximum of 26 characters',
  ROWS: 'Maximum rows exceeded',
};
